import { useEffect, useState } from 'react'
import { Loader2 } from 'lucide-react'
import { MaintenanceSnakeGame } from './maintenance-snake-game'

const GRID_PATTERN_ID = 'maintenance-bg-grid'

const TIPS = [
  'Tuning servers and polishing pixels.',
  'We will be right back.',
  'Thanks for hanging tight.',
]

export function MaintenanceScreen() {
  const [tipIndex, setTipIndex] = useState(0)

  useEffect(() => {
    const id = window.setInterval(() => {
      setTipIndex((i) => (i + 1) % TIPS.length)
    }, 4200)
    return () => window.clearInterval(id)
  }, [])

  return (
    <div className="maintenance-root relative flex min-h-screen flex-col items-center justify-center overflow-hidden bg-[hsl(240_18%_6%)] px-6 text-[hsl(0_0%_98%)]">
      <div
        className="pointer-events-none absolute inset-0 opacity-90"
        style={{
          background:
            'radial-gradient(ellipse 80% 50% at 50% -20%, hsl(var(--primary) / 0.35), transparent), radial-gradient(ellipse 60% 40% at 100% 50%, hsl(var(--accent) / 0.22), transparent), radial-gradient(ellipse 50% 60% at 0% 80%, hsl(239 84% 55% / 0.2), transparent)',
        }}
      />
      <div className="maintenance-aurora pointer-events-none absolute -inset-[40%] opacity-60 blur-3xl" />

      <svg className="pointer-events-none absolute inset-0 h-full w-full opacity-[0.12]" aria-hidden>
        <defs>
          <pattern id={GRID_PATTERN_ID} width="48" height="48" patternUnits="userSpaceOnUse">
            <path d="M48 0H0V48" fill="none" stroke="currentColor" strokeWidth="0.5" className="text-white" />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill={`url(#${GRID_PATTERN_ID})`} className="maintenance-grid-shift" />
      </svg>

      <div className="pointer-events-none absolute inset-0 overflow-hidden">
        {[...Array(18)].map((_, i) => (
          <span
            key={i}
            className="maintenance-orb absolute h-1 w-1 rounded-full bg-white/70 shadow-[0_0_12px_hsl(var(--primary)/0.9)]"
            style={{
              left: `${(i * 47 + 13) % 100}%`,
              top: `${(i * 31 + 7) % 100}%`,
              animationDelay: `${i * 0.35}s`,
            }}
          />
        ))}
      </div>

      <main className="relative z-10 flex w-full max-w-4xl flex-col items-center px-2 text-center sm:px-4">
        <div className="maintenance-glow-ring mb-10 flex h-24 w-24 items-center justify-center rounded-2xl border border-white/10 bg-white/5 shadow-2xl backdrop-blur-md">
          <Loader2 className="h-11 w-11 animate-spin text-[hsl(var(--primary))]" aria-hidden />
          <span className="sr-only">Loading</span>
        </div>

        <h1 className="maintenance-title-shimmer bg-clip-text text-3xl font-semibold tracking-tight text-transparent sm:text-4xl">
          We are under maintenance
        </h1>
        <p className="mt-4 text-balance text-base leading-relaxed text-white/75 sm:text-lg">
          Comfyflow is getting a quick upgrade. Please check back soon — we are working as fast as we can.
        </p>
        <p
          className="mt-6 min-h-[1.5rem] text-sm text-white/55 transition-opacity duration-500"
          key={tipIndex}
        >
          {TIPS[tipIndex]}
        </p>

        <div className="mt-10 h-1 w-full max-w-xs overflow-hidden rounded-full bg-white/10">
          <div className="maintenance-progress h-full rounded-full bg-gradient-to-r from-[hsl(var(--primary))] via-[hsl(var(--accent))] to-[hsl(var(--primary))]" />
        </div>

        <MaintenanceSnakeGame />
      </main>
    </div>
  )
}
